/*
Gestión de la calidad = 0
Investigación e Innovación = 1
Tecnologías de producción = 2
Ciencias Básicas = 3
Ciencias complementarias = 4
*/

export const career_data = {
    name: "Ingeniería en Calidad y Tecnologías de Producción con grado en Bachillerato (BA-ICTEPR) y Licenciatura (LI-ICTEPR)",
    code: "ICTEPR",
    mesh: {
        "0 0": {
            "#Gestión de la calidad": ["Gestión de la calidad", [], 0],
            "#Investigación e Innovación": ["Investigación e Innovación", [], 1],
            "#Tecnologías de producción": ["Tecnologías de producción", [], 2],
            "#Ciencias Básicas": ["Ciencias Básicas", [], 3],
            "#Ciencias complementarias": ["Ciencias complementarias", [], 4]
        },
        "1 1": {
            "MAT001": ["Matemática General", [], 3],
            "QUX101": ["Química General I", ["QUX101L"], 3],
            "QUX101L": ["Laboratorio de Química General I", ["QUX101"], 3],
            "ICT400": ["Gestión de la innovación", [], 1],
            "GEN1": ["Estudios generales I", [], 4],
            "GEN2": ["Estudios generales II", [], 4]
        },
        "1 2": {
            "MAT002": ["Cálculo I", ["MAT001"], 3],
            "QUX102": ["Química General II", ["QUX101", "QUX102L"], 3],
            "QUX102L": ["Laboratorio de Química General II", ["QUX101", "QUX102"], 3],
            "ICT401": ["Dibujo Técnico Asistido por Computadora", [], 2],
            "GEN3": ["Estudios generales III", [], 4],
            "GEN4": ["Estudios generales IV", [], 4]
        },
        "2 1": {
            "MAT003": ["Cálculo II", ["MAT002"], 3],
            "QUX107": ["Fundamentos de Química Analítica", ["QUX102", "QUX107L"], 3],
            "QUX107L": ["Laboratorio de Fundamentos de Química Analítica", ["QUX102", "QUX107"], 3],
            "FIX422": ["Física I", ["MAT002", "FIX422L"], 3],
            "FIX422L": ["Laboratorio de Física I", ["MAT002", "FIX422"], 3],
            "LIX410": ["Inglés integrado para otras carreras I", [], 4]
        },
        "2 2": {
            "MAT005": ["Álgebra Lineal", ["MAT003"], 3],
            "MAT009": ["Estadística Descriptiva", ["MAT001"], 3],
            "FIX423": ["Física II", ["FIX422", "MAT003", "FIX423L"], 3],
            "FIX423L": ["Laboratorio de Física II", ["FIX422", "FIX423"], 3],
            "ICT402": ["Programación para ingeniería", ["MAT001"], 2],
            "LIX411": ["Inglés integrado para otras carreras II", ["LIX410"], 4]
        },
        "3 1": {
            "MAT040": ["Ecuaciones Diferenciales", ["MAT005", "ICT404"], 3],
            "ICT403": ["Estadística Inferencial", ["MAT009"], 3],
            "ICT404": ["Principios de Electromecánica", ["FIX423", "ICT402", "ICT404L"], 2],
            "ICT404L": ["Laboratorio de Principios de Electromecánica", ["FIX423", "ICT404"], 2],
            "OPT1": ["Optativo I Libre", [], 4],
            "LIX412": ["Inglés integrado para otras carreras III", ["LIX411"], 4]
        },
        "3 2": {
            "ICT405": ["Investigación de Operaciones", [], 2],
            "ICT406": ["Gestión Integral de la Calidad", [], 0],
            "ICT407": ["Fundamentos de Mecatrónica", ["ICT404", "ICT407L"], 2],
            "ICT407L": ["Laboratorio de Fundamentos de Mecatrónica", ["ICT404", "ICT404L", "ICT407"], 2],
            "ICT408": ["Administración para Ingeniería", [], 4],
            "OPT2": ["Optativo II Libre", [], 4]
        },
        "4 1": {
            "ICT409": ["Administración de Procesos de Producción", ["ICT405"], 2],
            "ICT410": ["Aseguramiento de la Calidad", ["ICT405", "ICT406"], 0],
            "ICT411": ["Metrología y Sistemas de Gestión", ["ICT406", "FIX423", "ICT411L"], 0],
            "ICT411L": ["Laboratorio de Metrología", ["ICT411"], 0],
            "ICT412": ["Gestión de Costos de Ingeniería", ["ICT408", "MAT001"], 2],
            "OPT3": ["Optativo III Disciplinar", [], 4]
        },
        "4 2": {
            "ICT413": ["Seguridad Ocupacional en la Industria", ["ICT410", "ICT414"], 0],
            "ICT414": ["Formulación y Evaluación de Proyectos", ["ICT410", "ICT408"], 2],
            "OPT4": ["Optativo IV Disciplinar", [], 4],
            "PPS": ["Práctica Profesional Supervisada", [], 4]
        },
        "5 1": {
            "ICT500": ["Ética y liderazgo para Ingeniería", [], 4],
            "ICT501": ["Tecnologías aplicadas a los procesos productivos", [], 2],
            "ICT502": ["Gerencia de proyectos e innovación", [], 1],
            "ICT503": ["Diseño Estadístico de Experimentos", ["ICT503L"], 0],
            "ICT503L": ["Laboratorio de Diseño Estadístico de Experimentos", ["ICT503"], 0],
            "ICT504": ["Taller de investigación I", [], 4]
        },
        "5 2": {
            "ICT505": ["Tecnologías Ambientales", ["ICT501"], 1],
            "ICT506": ["Planificación y Control de Procesos Productivos", ["ICT501"], 2],
            "ICT507": ["Logística y cadena de suministro", ["ICT506"], 2],
            "OPT5": ["Optativo V Libre", [], 4],
            "ICT508": ["Taller de investigación II", ["ICT504"], 4],
            "ICT509": ["Trabajo Final de Graduación", ["ICT508"], 4]
        },
        "Opt": {
            "TGF100O": ["Fábrica digital", [], 4],
            "TGF101O": ["Industria 4.0", [], 4],
            "TGF102O": ["Introducción a la ciencia de datos", [], 4],
            "TGF103O": ["Internet de las cosas", [], 4],
        }
    }
};